// Auto generated file, do not manually modify!
// com.hotpads.rentcreditreport.client.enums.reportingforallenrollment.ReportingForAllEnrollmentStatus

export enum ReportingForAllEnrollmentStatus {
  COMPLETED_ENROLLMENT = 'COMPLETED_ENROLLMENT',
  INITIATED_ENROLLMENT = 'INITIATED_ENROLLMENT',
  LEASE_ENDED = 'LEASE_ENDED',
  NOT_ENROLLED = 'NOT_ENROLLED',
  UNENROLLED = 'UNENROLLED',
}

export const ReportingForAllEnrollmentStatus_values = [
  ReportingForAllEnrollmentStatus.COMPLETED_ENROLLMENT,
  ReportingForAllEnrollmentStatus.INITIATED_ENROLLMENT,
  ReportingForAllEnrollmentStatus.LEASE_ENDED,
  ReportingForAllEnrollmentStatus.NOT_ENROLLED,
  ReportingForAllEnrollmentStatus.UNENROLLED,
] as const;
